import React from "react";
import PropTypes from "prop-types";

import mutationFactory, {
  setCardToPinChange as setCardToPinChangeQ,
} from "model/gql/mutations";

const SetCardToPinChange = mutationFactory(setCardToPinChangeQ);

function CardPinChange(props) {
  const { cardId, children } = props;
  return cardId ? (
    <SetCardToPinChange cardId={props.cardId}>
      {({ mutate: setCardForPinChange }) => children({ setCardForPinChange })}
    </SetCardToPinChange>
  ) : (
    children({ setCardForPinChange: undefined })
  );
}

CardPinChange.displayName = "CardPinChange";

CardPinChange.propTypes = {
  children: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
};

CardPinChange.defaultProps = {};

export default CardPinChange;



// WEBPACK FOOTER //
// ./src/data-containers/CardPinChange/CardPinChange.js